/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_Auth_DescriptionInputs */

const en_landing_features_auth_description = /** @type {(inputs: Landing_Features_Auth_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email/password, Google, and GitHub OAuth — ready out of the box with session management and account linking.`)
};

const zh_landing_features_auth_description = /** @type {(inputs: Landing_Features_Auth_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱密码、Google、GitHub OAuth 登录，开箱即用，自带会话管理和账号关联。`)
};

/**
* | output |
* | --- |
* | "Email/password, Google, and GitHub OAuth — ready out of the box with session management and account linking." |
*
* @param {Landing_Features_Auth_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_auth_description = /** @type {((inputs?: Landing_Features_Auth_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_Auth_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_auth_description(inputs)
	return zh_landing_features_auth_description(inputs)
});
export { landing_features_auth_description as "landing.features.auth.description" }